module.exports = __webpack_public_path__ + "img/empty.80177df1.svg";